"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolderOutlineIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var FolderOutlineIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "none", stroke: "currentColor", strokeWidth: "2", d: "M5.33333333,6 C5.15285157,6 5,6.15531692 5,6.35483871 L5,17.6451613 C5,17.8446831 5.15285157,18 5.33333333,18 L18.6666667,18 C18.8471484,18 19,17.8446831 19,17.6451613 L19,8.16129032 C19,7.96176853 18.8471484,7.80645161 18.6666667,7.80645161 L11.1111111,7.80645161 C10.3730099,7.80645161 9.67962774,7.45416875 9.23987036,6.85836843 L8.70653703,6.13578777 C8.64268273,6.0492755 8.54569603,6 8.44444444,6 L5.33333333,6 Z" }))); };
exports.FolderOutlineIcon = FolderOutlineIcon;
